export const OFFER_PLAN_TYPES = {
  SVOD: "svod",
  TVOD: "tvod_bundle",
  FREE: "free",
} as const;

export const ACCESS_DURATION_TYPES = {
  UNLIMITED: "unlimited",
  DAY: "day",
  LIMIT_DATE: "limit_date",
} as const;

export const PLATFORM_TYPES = {
  OKAST: "okast",
  APPLE: "apple",
  GOOGLE: "google",
  RETAILER: "retailer",
  EDU: "edu",
} as const;

export type OfferPlatformValue =
  (typeof PLATFORM_TYPES)[keyof typeof PLATFORM_TYPES];

/** True for the app-store platforms, where billing (frequency/rental duration) is set by the store, not okast. */
export function isMobilePlatform(platform: string): boolean {
  return (
    platform === PLATFORM_TYPES.APPLE || platform === PLATFORM_TYPES.GOOGLE
  );
}

export function platformSupportsGeoblock(platform: string): boolean {
  return platform === PLATFORM_TYPES.OKAST || platform === PLATFORM_TYPES.EDU;
}

export const RESOLUTION_TYPES = {
  SD: "sd",
  HD: "hd",
  UHD: "uhd",
} as const;
